// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  height: 100vh;
  transition: all 0.3s ease;
  overflow-x: hidden;
}

/* Open state */
.sidebar.open {
  width: 250px;
}

/* Collapsed state */
.sidebar.collapsed {
  width: 60px;
}

/* Optional: icon alignment when collapsed */
.sidebar.collapsed  {
  text-align: center;
  padding-left: 0;
}

/* Default link */
.sidebar .nav-link {
  color: #000;
  padding: 10px 15px;
  transition: 0.3s;
}

/* Hover effect */
.sidebar .nav-link:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

/* Active menu highlight */
.sidebar .active-menu {
  background-color: #0d6efd;
  color: white !important;
  font-weight: bold;
  border-radius: 5px;
}




`, "",{"version":3,"sources":["webpack://./src/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;AACtC;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".sidebar {\r\n  height: 100vh;\r\n  transition: all 0.3s ease;\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* Open state */\r\n.sidebar.open {\r\n  width: 250px;\r\n}\r\n\r\n/* Collapsed state */\r\n.sidebar.collapsed {\r\n  width: 60px;\r\n}\r\n\r\n/* Optional: icon alignment when collapsed */\r\n.sidebar.collapsed  {\r\n  text-align: center;\r\n  padding-left: 0;\r\n}\r\n\r\n/* Default link */\r\n.sidebar .nav-link {\r\n  color: #000;\r\n  padding: 10px 15px;\r\n  transition: 0.3s;\r\n}\r\n\r\n/* Hover effect */\r\n.sidebar .nav-link:hover {\r\n  background-color: rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Active menu highlight */\r\n.sidebar .active-menu {\r\n  background-color: #0d6efd;\r\n  color: white !important;\r\n  font-weight: bold;\r\n  border-radius: 5px;\r\n}\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
